module.exports = __webpack_public_path__ + "static/media/galerija_2017 (29).878555e9.jpg";